// Centralized enums for Immunization scheduling related query parameters

export const SiteEnum = Object.freeze({
  DEFAULT: 'default',
  SCAN: 'scan',
  HAP: 'hap'
})

export const isValidSite = value => Object.values(SiteEnum).includes((value || '').toLowerCase())

// Services enum for broader health-related offerings
export const ServiceEnum = Object.freeze({
  VACCINATIONS: 'Vaccinations',
  TESTING: 'Testing',
  HEALTH_CARE_PLAN: 'Healthcare Plan'
})

export const isValidService = value =>
  Object.values(ServiceEnum).includes((value || '').toLowerCase())
